import React from 'react';
import PropTypes from 'prop-types';
import { Backdrop, Box, CircularProgress, Stack } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingSpinner = _ref => {
  let {
    isActive,
    variant,
    message
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Backdrop, {
      sx: {
        zIndex: theme => theme.zIndex.drawer + 1
      },
      open: isActive,
      children: /*#__PURE__*/_jsxs(Stack, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(CircularProgress, {
          sx: {
            justifySelf: 'center'
          },
          color: variant
        }), message && /*#__PURE__*/_jsx(Box, {
          component: "p",
          sx: {
            color: theme => theme.palette[variant].text
          },
          children: message
        })]
      })
    })
  });
};
LoadingSpinner.propTypes = {
  messageAlign: PropTypes.oneOf(['left', 'right', 'center']),
  message: PropTypes.string,
  isActive: PropTypes.bool,
  variant: PropTypes.oneOf(['background', 'primary', 'accent', 'secondary', 'error', 'tertiary', 'success'])
};
LoadingSpinner.defaultProps = {
  messageAlign: 'center',
  message: null,
  isActive: false,
  variant: 'accent'
};
export default LoadingSpinner;